<template>
    <div class="mb-4">
        <b-table v-if="!showNoRowsText" :fields="tableFields" :items="getTableItems">
            <template v-slot:cell(invoicingModalityArticleName)="rowData">
                {{ getRowForm(rowData).getDataOfProperty('invoicingModalityArticleName') }}
            </template>
            <template v-slot:cell(serviceRecipientFirmName)="rowData">
                {{ getRowForm(rowData).getDataOfProperty('serviceRecipientFirmName') }}
            </template>
            <template v-slot:cell(fee)="rowData">
                <csp-form-group-input-currency
                    :form="getRowForm(rowData)"
                    hide-arrows
                    hide-label
                    list="fee-suggestions"
                    property="fee"
                    :readonly="isFeeInputReadonly(rowData)"/>
            </template>
            <template v-slot:cell(invoiceRecipient)="rowData">
                <csp-form-group-select-searchable
                    :form="getRowForm(rowData)"
                    hide-label
                    :options="invoiceRecipientOptions"
                    property="invoiceRecipient"
                    @change="handleInvoiceRecipientChange($event, rowData)"/>
            </template>
            <template v-slot:cell(invoiceRecipientAddressNo)="rowData">
                <csp-form-group-input
                    :disabled="isAddressNoInputDisabled(rowData)"
                    :form="getRowForm(rowData)"
                    hide-label
                    property="invoiceRecipientAddressNo"/>
            </template>
        </b-table>

        <datalist id="fee-suggestions">
            <option v-for="(feeSuggestion, index) in feeSuggestions" :key="index">
                {{ feeSuggestion }}
            </option>
        </datalist>

        <div v-if="showNoRowsText">
            {{ noRowsText }}
        </div>
    </div>
</template>

<script>
    import Form from '@form/Form';
    import '@desktop/scss/components/invoicing-modality-table.scss'

    export default {
        props: {
            /** options for invoice recipient select fields */
            invoiceRecipientOptions: {
                type: Array,
                required: true,
            },
            /** text to display in place of table body if the table has no rows */
            noRowsText: {
                type: String,
                default: null,
                required: false,
            },
            tableFields: {
                type: Array,
                required: true,
            },
            tableForm: {
                type: Form,
                required: true,
            },
        },
        data() {
            return {
                // fee suggestions will be added later
                /** suggestions for the fee input fields */
                feeSuggestions: [],
            }
        },
        computed: {
            showNoRowsText() {
                return Object.keys(this.tableForm.getData()).length === 0;
            },
        },
        methods: {
            getRowForm(rowData) {
                return this.tableForm.getSubform(rowData.item.tableRowFormIndex);
            },
            getTableItems() {
                const tableItems = [];

                // tableItems is going to be an array of objects which only contain the index for the respective
                // table row subform within the table form

                Object.values(this.tableForm.getData()).forEach(
                    (rowForm, index) => {
                        const row = {tableRowFormIndex: index};
                        if (rowForm.data.attributes.isRemnant) {
                            row._rowVariant = 'warning';
                            row.isFeeInputReadonly = true;
                        }
                        tableItems.push(row);
                    }
                );

                return tableItems;
            },
            handleInvoiceRecipientChange(value, rowData) {
                if (value !== 'differing') {
                    // reset value of address number input field
                    this.getRowForm(rowData).setProperty('invoiceRecipientAddressNo', null);
                }
            },
            isAddressNoInputDisabled(rowAttributes) {
                return this.getRowForm(rowAttributes).getDataOfProperty('invoiceRecipient') !== 'differing';
            },
            isFeeInputReadonly(rowData) {
                return rowData?.item?.isFeeInputReadonly;
            },
        },
    }
</script>
